import type { Column } from '@tanstack/react-table';
import { isNil } from 'es-toolkit';

import type { FilterOption } from '../types/filter-option';

/**
 * Returns filter options for a column.
 * Uses explicit options from meta if provided, otherwise derives from faceted unique values.
 */
export function getFilterOptions<TData>(column: Column<TData>): FilterOption[] {
  const meta = column.columnDef.meta?.filter;

  // Explicit options take precedence
  if (meta && 'options' in meta && meta.options) {
    return [...meta.options];
  }

  // Fall back to faceted unique values
  const facetedValues = column.getFacetedUniqueValues();

  return Array.from(facetedValues.keys())
    .filter((value) => !isNil(value))
    .map((value) => ({
      label: String(value),
      value: value as string | number,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
